export default __webpack_public_path__ + "static/media/walkthrough-step2-4K.378154c4.jpg";